import LoadPanel from 'devextreme-react/load-panel';
import 'devextreme/dist/css/dx.common.css';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Content from './Content';
import { AuthProvider, useAuth } from './contexts/auth';
import { NavigationProvider } from './contexts/navigation';
import './dx-styles.scss';
import './themes/generated/theme.additional.css';
import './themes/generated/theme.base.css';
//import './themes/custom-theme/dx.material.custom-scheme.css';
import { useScreenSizeClass } from './utils/media-query';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  return <Content />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();

  return (
    <Router>
      <AuthProvider>
        <NavigationProvider>
          <div className={`app ${screenSizeClass}`}>
            <App />
          </div>
        </NavigationProvider>
      </AuthProvider>
    </Router>
  );
}
